<template>
  <div class="headerChecBox">
    <el-checkbox v-model="checked" v-show="checboxShow()" @change="changeAllSelect"></el-checkbox>
  </div>
</template>
<script>
import { Checkbox } from 'element-ui';
import Vue from 'vue';

Vue.use(Checkbox);
export default {
  // data 为scope type 1 远程审方药师 2 驻店 3 人脸 4 调配 5 发药 6 视频先问后诊 7-三方审方中心 8 图文问诊开关
  // isHead 是否表头
  // listData scope
  props: ['type', 'List'],
  watch: {
    mode() {
      this.renderRes();
    }
  },

  data() {
    return {
      checked: false
    };
  },
  computed: {
    mode() {
      return this.$store.getters.getShopManagementMode;
    },
    getchangeSetingList() {
      return this.$store.getters.getchangeSetingList;
    }
  },
  methods: {
    stop() {},
    renderRes() {
      // 渲染编辑模式数据 getchangeSetingList
      this.checked = false;
    },
    changeAllSelect() {
      // 优化代码
      // 状态变更
      const { type, List, getchangeSetingList } = this;

      List.map(v => {
        let FEremote = String(v.remotePharmacistStatus);
        let FEpha = String(v.storePharmacistStatus);
        let FEface = String(v.faceStatus);
        let FElpcStatus = Number(Boolean(v.localPrescriptionsCenter));
        // 修复历史数据不存在时，设置初值
        let FEdispenseStatus = String(v.dispenseStatus || 0);
        let FEdispatchStatus = String(v.dispatchStatus || 0);
        let FEDiagnoseBeforeAskStatus = String(v.diagnoseBeforeAskStatus || 0);
        let FEUserPicStatus = String(v.userPicStatus || 0);
        getchangeSetingList.filter(f => {
          // 如果该元素存在在设置列表中把它已存在的属性先取出来
          if (f.id == v.id) {
            // 取旧值
            if (f.FEpha) {
              FEpha = String(f.FEpha); // 转字符串不然下面判断会出错
            }
            if (f.FEface) {
              FEface = String(f.FEface);
            }
            if (f.FEremote) {
              FEremote = String(f.FEremote);
            }
            if (f.FEdispenseStatus) {
              FEdispenseStatus = String(f.FEdispenseStatus);
            }
            if (f.FEdispatchStatus) {
              FEdispatchStatus = String(f.FEdispatchStatus);
            }
            if (f.FEDiagnoseBeforeAskStatus) {
              FEDiagnoseBeforeAskStatus = String(f.FEDiagnoseBeforeAskStatus);
            }
            if (f.FElpcStatus) {
              FElpcStatus = String(f.FElpcStatus);
            }
            if (f.FEUserPicStatus) {
              FEUserPicStatus = String(f.FEUserPicStatus);
            }
          }
        });
        if (type == 1) {
          FEremote = this.genValue(type, v, FEpha, FEface, FEremote);
        }
        if (type == 2) {
          FEpha = this.genValue(type, v, FEpha, FEface, FEremote);
        }
        if (type == 3) {
          FEface = this.genValue(type, v, FEpha, FEface, FEremote);
        }
        if (type == 4) {
          FEdispenseStatus = this.genValue(type);
        }
        if (type == 5) {
          FEdispatchStatus = this.genValue(type);
        }
        if (type == 6) {
          FEDiagnoseBeforeAskStatus = this.genValue(type);
        }
        if (type == 7) {
          FElpcStatus = this.genValue(type);
        }
        if (type == 8) {
          FEUserPicStatus = this.genValue(type);
        }
        if (v.disableStatus == 1) {
          // 拦截已经被禁用的店铺
          return;
        }
        this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
          ...v,
          FEremote,
          FEpha,
          FEface,
          FEdispenseStatus,
          FEdispatchStatus,
          FEDiagnoseBeforeAskStatus,
          FElpcStatus,
          FEUserPicStatus
        });
      });
    },
    genValue(type, v, FEpha, FEface, FEremote) {
      // 生成对应值  主要处理一些不能选中和不能取消的情况
      if (type == 1) {
        if (v.remotePharmacist.length == 0) {
          // 远程药师不存在的 不允许选中
          return '0';
        }
        if (FEface == 1 && FEpha == 0) {
          if (Number(this.checked) == 0) {
            // 如果人脸识别开启 驻店不开启 并且点击让他关闭 阻止关闭
            return String(1);
          }
        }
        return String(Number(this.checked));
      }
      if (type == 2) {
        if (v.drugstorePharmacist.length == 0) {
          // 没有驻店药师不给选中
          return String(0);
        }
        if (FEface == 1 && FEremote == 0) {
          // 人脸识别开启 远程关闭 不给关闭
          return String(1);
        }
        return String(Number(this.checked));
      }
      if (type == 3) {
        if (FEremote == 0 && FEpha == 0) {
          // 远程审方跟驻店审方都没打开时 人脸识别不给打开
          return String(0);
        }
        return String(Number(this.checked));
      }
      return String(Number(this.checked));
    },
    Cchange() {
      // 状态变更

      const { type, List, getchangeSetingList } = this;
      const _this = this;

      if (type == 1) {
        let FEremote = null;
        List.map(v => {
          let FEpha = null;
          let FEface = null;
          let res = getchangeSetingList.filter(f => {
            // 如果该元素存在在设置列表中把它已存在的属性先取出来
            if (f.id == v.id) {
              FEpha = f.FEpha + ''; // 转字符串不然下面判断会出错
              FEface = f.FEface + '';
            }
          });
          FEpha = FEpha || v.storePharmacistStatus;
          FEface = FEface || v.faceStatus;

          FEremote = (function () {
            if (v.remotePharmacist.length == 0) {
              // 远程药师不存在的 不允许选中
              return 0;
            }
            if (FEface == 1 && FEpha == 0) {
              if (Number(_this.checked) == 0) {
                // 如果人脸识别开启 驻店不开启 并且点击让他关闭 阻止关闭
                return 1;
              }
            }
            // 应该还有其他情况 想不起来了
            return Number(_this.checked);
          })();

          this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
            ...v,
            FEremote,
            FEpha,
            FEface
          });
        });
        return;
      }
      if (type == 2) {
        let FEpha = null;
        List.map(v => {
          let FEremote = null;
          let FEface = null;
          let res = getchangeSetingList.filter(f => {
            // 如果该元素存在在设置列表中把它已存在的属性先取出来
            if (f.id == v.id) {
              FEremote = f.FEremote + '';
              FEface = f.FEface + '';
            }
          });
          FEremote = FEremote || v.remotePharmacistStatus;
          FEface = FEface || v.faceStatus;
          FEpha = (function () {
            if (v.drugstorePharmacist.length == 0) {
              // 没有驻店药师不给选中
              return 0;
            }
            if (FEface == 1 && FEremote == 0) {
              // 人脸识别开启 远程关闭 不给关闭
              return 1;
            }
            // 其他情况
            return Number(_this.checked);
          })();

          this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
            ...v,
            FEpha,
            FEremote,
            FEface
          });
        });
        return;
      }
      if (type == 3) {
        let FEface = null;
        List.map(v => {
          let FEremote = null;
          let FEpha = null;
          let res = getchangeSetingList.filter(f => {
            // 如果该元素存在在设置列表中把它已存在的属性先取出来
            if (f.id == v.id) {
              FEremote = f.FEremote + '';
              FEpha = f.FEpha + '';
            }
          });
          FEremote = FEremote || v.remotePharmacistStatus;
          FEpha = FEpha || v.storePharmacistStatus;
          FEface = (function () {
            if (FEremote == 0 && FEpha == 0) {
              // 远程审方跟驻店审方都没打开时 人脸识别不给打开
              return 0;
            }
            return Number(_this.checked);
          })();

          this.$store.dispatch('shopManagement/UPDATESETINGLIST', {
            ...v,
            FEface,
            FEpha,
            FEremote
          });
        });
      }
    },
    renderText() {
      if (this.isHead) {
        return '';
      } else {
        return '开启';
      }
    },

    checboxShow() {
      if (this.mode == 2) {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.headerChecBox {
  float: left;
  line-height: normal;
  padding: 0;
  padding-right: 10px;
  .base {
    width: 14px;
    display: block;
    margin-left: 18px;
    margin-top: 8px;
  }
  .unselect {
    @extend .base;
  }
  .select_icon {
    @extend .base;
  }
}
</style>
